import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"
import "tom-select/dist/css/tom-select.bootstrap5.css"

export default class extends Controller {
  static targets = ["input", "selectedId", "email"]
  static values = {
    options: Array,
    placeholder: { type: String, default: "Search or enter email address..." }
  }

  connect() {
    this.initializeTomSelect()
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }

  initializeTomSelect() {
    const self = this
    const options = this.optionsValue.map(opt => ({
      value: opt.email,
      text: opt.email,
      id: opt.id
    }))

    this.tomSelect = new TomSelect(this.inputTarget, {
      options: options,
      valueField: "value",
      labelField: "text",
      searchField: ["text"],
      create: true,
      createOnBlur: true,
      maxItems: 1,
      placeholder: this.placeholderValue,
      persist: true,
      createFilter: (input) => {
        return this.isValidEmail(input)
      },
      plugins: ["remove_button"],
      render: {
        option: function(data, escape) {
          return `<div>${escape(data.text)}</div>`
        },
        item: function(data, escape) {
          return `<div>${escape(data.text)}</div>`
        },
        option_create: function(data, escape) {
          return `<div class="create">Invite: <strong>${escape(data.input)}</strong></div>`
        },
        no_results: function(data) {
          if (data.input && !self.isValidEmail(data.input)) {
            return `<div class="no-results">Enter a valid email address</div>`
          }
          return `<div class="no-results">No results found</div>`
        }
      },
      onItemAdd: (value) => {
        this.handleSelection(value)
      },
      onItemRemove: () => {
        this.clearHiddenFields()
      },
      onChange: (value) => {
        if (!value) {
          this.clearHiddenFields()
        }
      }
    })

    this.tomSelect.wrapper.classList.add("email-select-wrapper")
  }

  handleSelection(value) {
    const selectedOption = this.optionsValue.find(opt => opt.email === value)

    if (selectedOption) {
      this.selectedIdTarget.value = selectedOption.id
      this.emailTarget.value = ""
    } else {
      this.selectedIdTarget.value = ""
      this.emailTarget.value = value
    }
  }

  clearHiddenFields() {
    this.selectedIdTarget.value = ""
    this.emailTarget.value = ""
  }

  isValidEmail(input) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(input)
  }
}
